module.exports = __webpack_public_path__ + "img/trasmed.3f58190e.png";